module.exports = __webpack_public_path__ + "img/pages.2d22a924.svg";